import React, { createContext, ReactNode, useContext, useState } from 'react'

// Define the shape of the context data
interface FeatureListContextData {
  featureString: any
  setFeatureString: any
}

// Create the context
const FeatureListContext = createContext<FeatureListContextData | any>('')

// Create a provider component
export const FeatureListContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [featureString, setFeatureString] = useState<string | null>(null)
  console.log(featureString)
  return (
    <FeatureListContext.Provider value={{ featureString, setFeatureString }}>
      {children}
    </FeatureListContext.Provider>
  )
}

// Custom hook to access the context
export const useFeatureListContext = (): FeatureListContextData => {
  const context = useContext(FeatureListContext)
  if (!context) {
    throw new Error('useFeatureListContext must be used within a FeatureListContextProvider')
  }
  return context
}

export default FeatureListContext
